// Function to observe changes inside the panel
function observePanelChanges(panel) {
    var observer = new MutationObserver(function () {
        if (panel.classList.contains("active")) {
            panel.style.height = "auto";
            let newHeight = panel.clientHeight + "px";
            panel.style.height = newHeight;
        }
    });

    observer.observe(panel, { childList: true, subtree: true, characterData: true });
}

function avautuvaSisaltoToggle(header) {
    var panel = header.nextElementSibling;

    var plusicon = header.querySelector(".otsikko .icon-plus");
    var minusicon = header.querySelector(".otsikko .icon-minus");


    if (!panel.classList.contains("active")) {

        header.setAttribute("aria-expanded", "true");
        plusicon.classList.remove("show");
        plusicon.classList.add("hidden");
        minusicon.classList.remove("hidden");
        minusicon.classList.add("show");

        panel.classList.add("active");
        panel.style.height = "auto";

        var height = panel.clientHeight + "px";

        panel.style.height = "0px";

        setTimeout(function () {
            panel.style.height = height;
        }, 0);

        // Observe content changes and adjust height dynamically
        observePanelChanges(panel);

    } else {

        header.setAttribute("aria-expanded", "false");
        plusicon.classList.remove("hidden");
        plusicon.classList.add("show");
        minusicon.classList.remove("show");
        minusicon.classList.add("hidden");

        panel.style.height = "0px";

        panel.addEventListener("transitionend", function () {
            panel.classList.remove("active");
        }, {
        once: true
        });

    }
}




var avautuvasisalto = document.getElementsByClassName("piilotettusisalto__header");
var i;

function handleClick() {
    avautuvaSisaltoToggle(this);
}

function handleKeyUp(e) {
    e.preventDefault();
    if ( e.keyCode === 13 || e.keyCode === 32 ) { //enter, space
        avautuvaSisaltoToggle(this);
    }
}

for (i = 0; i < avautuvasisalto.length; i++) {
    avautuvasisalto[i].addEventListener("click", handleClick);
    avautuvasisalto[i].addEventListener("keyup", handleKeyUp);
}

if (window.location.hash) {
    var targetId = window.location.hash.substring(1); // Remove the '#' character
    var targetElement = document.getElementById(targetId);
    if (targetElement && targetElement.classList.contains("piilotettusisalto")) {
        var headerWithinTarget = targetElement.querySelector('.piilotettusisalto__header');
        if (headerWithinTarget) {
            // Add a delay of 500 milliseconds (adjust as needed)
            setTimeout(function() {
                // If the target element exists and has the class "avautuvasisalto__header",
                // trigger the toggle function using the header element found within it
                avautuvaSisaltoToggle(headerWithinTarget);

                // Remove the anchor from the URL
                window.history.replaceState(null, null, window.location.pathname + window.location.search);

            }, 1000); // Adjust delay time (in milliseconds) as needed
        }
    }
}
